import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {Outsourced} from "../Outsourced";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {gsap} from "gsap";
import {BasedCountUp} from "./BasedCountUp";
import {GSAPUtils} from "../utils/GSAPUtils";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {OutsourcedCrashGameWinPresentation} from "../gameflow/OutsourcedCrashGameWinPresentation";
import {OutsourcedCrashGameIdlePresentation} from "../gameflow/OutsourcedCrashGameIdlePresentation";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {OutsourcedSound} from "../sound/OutsourcedSound";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class CrashGame extends PIXI.Container {

    yesButton:ContinueButton;
    noButton:ContinueButton;
    stopButton:ContinueButton;
    startButton:ContinueButton;
    yesButtonCallback:Function;
    noButtonCallback:Function;
    stopButtonCallback:Function;
    startButtonCallback:Function;
    spine:PIXI.spine.Spine;
    promptBox:PIXI.Sprite;
    text:PIXI.Text;
    confirmationText:PIXI.Text;
    godModeDeluxeText:PIXI.Text;
    countUp:PIXI.BitmapText;
    currentMultiplier:number;
    lostGame:boolean;
    hasStarted:boolean;
    crashedInstantly:boolean
    hasPressedButton:boolean;
    logo:PIXI.Sprite;
    replayClick:TimelineSprite;

    constructor() {
        super();

        const translations = Outsourced.apiPlugin.translations;
        const assetLoader = Outsourced.assetLoader;

        this.yesButton = new ContinueButton(translations.translate("YES"));
        this.yesButton.setSize(240, 120);
        this.yesButtonCallback = this.confirmation;
        this.yesButton.addClickCallback(() => this.yesButtonCallback());
        this.yesButton.position.set(210, 560);
        this.yesButton.pivot.set(this.yesButton.width * 0.5, this.yesButton.height * 0.5);
        this.yesButton.enable(false);
        this.yesButton.alpha = 0;

        this.noButton = new ContinueButton(translations.translate("NO"));
        this.noButton.setSize(240, 120);
        this.noButtonCallback = this.disable;
        this.noButton.addClickCallback(() => this.noButtonCallback());
        this.noButton.position.set(510, 560);
        this.noButton.pivot.set(this.noButton.width * 0.5, this.noButton.height * 0.5);
        this.noButton.enable(false);
        this.noButton.alpha = 0;

        this.stopButton = new ContinueButton(translations.translate("STOP"));
        this.stopButton.setSize(240, 120);
        this.stopButtonCallback = this.stop;
        this.stopButton.addClickCallback(() => this.stopButtonCallback());
        this.stopButton.position.set(360, 360);
        this.stopButton.pivot.set(this.noButton.width * 0.5, this.noButton.height * 0.5);
        this.stopButton.enable(false);
        this.stopButton.alpha = 0;

        this.startButton = new ContinueButton(translations.translate("START"));
        this.startButton.setSize(240, 120);
        this.startButtonCallback = this.start;
        this.startButton.addClickCallback(() => this.startButtonCallback());
        this.startButton.position.set(360, 560);
        this.startButton.pivot.set(this.noButton.width * 0.5, this.noButton.height * 0.5);
        this.startButton.enable(false);
        this.startButton.alpha = 0;

        this.spine = new PIXI.spine.Spine(assetLoader.getSpineAsset(OutsourcedGameAssets.CRASH_GAME_SPINE));
        this.spine.position.set(360, 360);
        this.spine.alpha = 0;

        this.promptBox = new PIXI.Sprite(assetLoader.getTextures("Info_Window")[0]);
        this.promptBox.position.set(360, 360);
        this.promptBox.anchor.set(0.5, 0.5);

        const textStyle = new PIXI.TextStyle({
            fill: "#00FF66",
            fontFamily: "Helvetica",
            fontSize: 40,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8,
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,

        });
        this.text = new PIXI.Text(NolimitApplication.apiPlugin.translations.translate(Outsourced.apiPlugin.gameClientConfiguration.showLowProbabilityGfx?"Bet your Max Win and win up to 50,000x or lose it all!":"Bet your win of 5000 times the bet and win any amount from 5000x - 50,000x or lose it all!"), textStyle);
        this.text.position.set(360, 360);
        this.text.anchor.set(0.5, 0.5);
        this.text.visible = false;

        this.confirmationText = new PIXI.Text(NolimitApplication.apiPlugin.translations.translate("Really!?"), Object.assign({}, textStyle, {
            fill: "#ee2553",
            fontSize: 80,
            stroke: "#232323",
        }));
        this.confirmationText.position.set(360, 360);
        this.confirmationText.anchor.set(0.5, 0.5);
        this.confirmationText.visible = false;

        this.godModeDeluxeText = new PIXI.Text("SLASH GAME", textStyle);
        this.godModeDeluxeText.position.set(360, 360);
        this.godModeDeluxeText.anchor.set(0.5, 0.5);
        this.godModeDeluxeText.visible = false;

        this.countUp = new PIXI.BitmapText("5000X", {
            fontName : OutsourcedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 50,
        });
        this.countUp.position.set(360, 540);
        (<PIXI.Point>this.countUp.anchor).set(0.5, 0.5);
        this.countUp.visible = false;
        this.currentMultiplier = 5000;

        this.logo = new PIXI.Sprite(Outsourced.assetLoader.getTextures("Logo_SG")[0]);
        this.logo.scale.set(0.65,0.65);
        this.logo.anchor.set(0.5,0.5);
        this.logo.visible = false;

        this.replayClick = new TimelineSprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.REPLAY_CLICK));
        this.replayClick.blendMode = PIXI.BLEND_MODES.ADD;
        this.replayClick.scale.set(2,2);
        this.replayClick.anchor.set(0.5, 0.5);
        this.replayClick.position.set(360, 560);
        this.replayClick.hide();

        this.alpha = 0;

        this.addChild(this.spine);
        this.addChild(this.countUp);
        this.addChild(this.promptBox);
        this.addChild(this.text);
        this.addChild(this.confirmationText);
        this.addChild(this.godModeDeluxeText);
        this.addChild(this.noButton);
        this.addChild(this.yesButton);
        this.addChild(this.stopButton);
        this.addChild(this.startButton);
        this.addChild(this.logo);
        this.addChild(this.replayClick);
    }

    public onResize() {
        if (NolimitApplication.isLandscape){
            this.logo.scale.set(0.65, 0.65);
            this.logo.position.set((NolimitApplication.screenBounds.left - 20) / 2, 80);
        } else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, (NolimitApplication.screenBounds.top + 44) / 2);
        }
    }

    enable():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                Outsourced.soundPlayer.playLoopBased("slashGameAnythingElseLoop");
                this.currentMultiplier = 5000;
                this.promptBox.visible = true;
                this.text.visible = true;
                this.confirmationText.visible = false;
                this.godModeDeluxeText.visible = false;
                this.yesButton.enable(true);
                this.noButton.enable(true);
                this.yesButton.alpha = 1;
                this.noButton.alpha = 1;
                this.yesButtonCallback = this.confirmation;
                this.noButtonCallback = this.disable;
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 1}), '<')
            //.add(gsap.to(this.noButton, {duration: 0.2, alpha: 1}), '<')
            //.add(gsap.to(this.yesButton, {duration: 0.2, alpha: 1}), '<')
    }

    enableFeatureBuy():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.currentMultiplier = 5000;
                this.promptBox.visible = true;
                this.text.visible = false;
                this.confirmationText.visible = false;
                this.godModeDeluxeText.visible = true;
                this.startButton.enable(true);
                this.startButton.alpha = 1;
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 1}), '<')
    }

    disable():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                Outsourced.soundPlayer.fadeInMusic();
                this.noButton.enable(false);
                this.yesButton.enable(false);
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
                Outsourced.apiPlugin.betHandler.zeroBet({playCrashGame:0, crashGameMultiplier:50000})
                this.yesButton.alpha = 0;
                this.noButton.alpha = 0;
                Outsourced.soundPlayer.stopLoopBased("slashGameAnythingElseLoop");
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 0}), '<')
    }

    confirmation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.noButtonCallback = () => {
                    this.enable();
                    Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
                }
                this.yesButtonCallback = this.start;
                this.text.visible = false;
                this.confirmationText.visible = true;
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
            })
    }

    // magic number 0.23026 is so f(0) = 5000 and f(10) = 50000
    start() {
        //const crashGameMulti = BrickSnake2000.model.data.crashGameMultiplier
        //const killTime = (crashGameMulti - 5000) / 4500;
        //const killTime = Math.log(crashGameMulti / 5000) / 0.23026;
        const animation = SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming")
        const hackjob = {bruh: 0};

        const introAnimation = gsap.timeline()
            .add(Outsourced.soundPlayer.stopLoopBased("slashGameAnythingElseLoop"))
            .add(Outsourced.soundPlayer.playSoundBased("slashGameStart"))
            .add(SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming_Intro_A"))
            .add(SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming_Intro_B"))
        const gameTimeline = gsap.timeline({onUpdate: () => {
                this.currentMultiplier = 5000 * Math.exp(0.23026 * hackjob.bruh);
                if (!this.crashedInstantly)
                    this.countUp.text = `${Math.floor(this.currentMultiplier)}X`
            }})
            .add(() => {
                Outsourced.apiPlugin.betHandler.zeroBet({playCrashGame:1})
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
                this.yesButton.enable(false);
                this.noButton.enable(false);
                this.yesButton.alpha = 0;
                this.noButton.alpha = 0;

                this.startButton.enable(false);
                this.startButton.alpha = 0;
                this.godModeDeluxeText.visible = false;

                this.crashedInstantly = false;
                this.hasStarted = false;
                this.lostGame = false;
                this.countUp.text = "5000X";
                this.countUp.visible = true;
                this.countUp.position.set(360, 540);
                this.countUp.scale.set(1,1);
                this.spine.alpha = 1;
                this.promptBox.visible = false;
                this.confirmationText.visible = false;
                this.stopButton.enable(false);
                this.stopButton.alpha = 0.6;
                this.hasPressedButton = false;
                this.logo.visible = true;
                Outsourced.soundPlayer.fadeOutMusic();
            })
            .add(introAnimation)
            .add(Outsourced.soundPlayer.playSoundBased("slashGameMusic"))
            .add(() => {
                this.hasStarted = true;
                this.stopButton.alpha = 1;
                this.stopButton.enable(true);
                this.stopButton.position.set(360, 360);
                this.stopButtonCallback = () => {
                    const jeff = introAnimation.duration() / gameTimeline.duration();
                    const bruh = 1 - jeff;
                    const progress = (gameTimeline.progress() - jeff) / bruh;
                    const multi = Math.floor(this.currentMultiplier);
                    this.countUp.text = `${multi}X`
                    this.lostGame = false;
                    this.hasPressedButton = true;
                    gameTimeline.kill();
                    this.stop();
                    Outsourced.soundPlayer.playSoundBased("slashGameWin");
                    Outsourced.soundPlayer.stopSound("slashGameMusic");
                    Outsourced.apiPlugin.betHandler.zeroBet({crashGameMultiplier: multi})
                }

                if (this.crashedInstantly) {
                    const multi = 5000;
                    this.countUp.text = `${multi}X`
                    this.lostGame = true
                    gameTimeline.kill();
                    this.stop();
                    Outsourced.soundPlayer.playSoundBased("slashGameMiss");
                    Outsourced.soundPlayer.stopSound("slashGameMusic");
                    Outsourced.soundPlayer.playLoopingSound("slashGameAnythingElseLoop");
                    gsap.timeline()
                        .add(SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming_Intro_Lose"))
                        .add(() => {this.spine.state.setAnimation(0, "Gaming_Intro_Lose_Loop", true)})
                    Outsourced.apiPlugin.betHandler.zeroBet({crashGameMultiplier:50000})
                }
            })
            .add(animation)
            .add(gsap.to(this, {currentMultiplier: 50000, duration: animation.duration(), ease:"none"}), '<')
            .add(gsap.to(hackjob, {bruh: 10, duration: 10, ease: "none"}), '<')
            //.add(SpineGSAPWrapper.createTimeline(this.spine, 0, "Win_Intro"))

        Outsourced.apiPlugin.events.once("OutsourcedCrashGameMultiplier", (data:number) => {
            if (this.hasPressedButton || Outsourced.model.isRestore)
                return;

            if (this.hasStarted) {
                //const multi = BrickSnake2000.model.data.crashGameMultiplier;
                const multi = data;
                this.countUp.text = `${multi}X`
                this.lostGame = multi != 50000;
                gameTimeline.kill();
                this.stop();
                Outsourced.soundPlayer.stopSound("slashGameMusic");
                if (this.lostGame) {
                    Outsourced.soundPlayer.playSoundBased("slashGameMiss");
                    Outsourced.soundPlayer.playLoopingSound("slashGameAnythingElseLoop");
                }
                Outsourced.apiPlugin.betHandler.zeroBet({crashGameMultiplier:50000})
            } else {
                this.crashedInstantly = true;
            }
        });
    }

    stop():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.countUp.position.set(360, 440);
                this.stopButton.enable(false);
                if (!this.crashedInstantly)
                    this.spine.state.setAnimation(0, this.lostGame ? "Lose" : "Win_Loop", true);
                if (this.lostGame) {
                    this.countUp.position.set(360, 340);
                    this.countUp.text = "0";
                    this.countUp.scale.set(1.5, 1.5);
                }
                this.stopButton.alpha = 0;
            })
            .add(Outsourced.soundPlayer.playLoopBased(this.lostGame ? "" : "slashGameWinLoop"))
    }

    done():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.spine.state.setEmptyAnimation(0, 0);
                this.spine.alpha = 0;
                this.logo.visible = false;
                Outsourced.soundPlayer.stopSound("slashGameWinLoop");
                Outsourced.soundPlayer.stopSound("slashGameAnythingElseLoop");
                Outsourced.soundPlayer.fadeInMusic();
            })
            .add(gsap.to(this, {alpha: 0, duration:0.2}), '<');
    }

    restore():void {
        this.promptBox.visible = false;
        this.alpha = 1;
        this.spine.alpha = 1;
        SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming_Intro_A").progress(1);
    }

    setDead():void {
        this.countUp.visible = true;
        this.countUp.position.set(360, 340);
        this.countUp.text = "0";
        this.countUp.scale.set(1.5, 1.5);
        this.spine.state.setAnimation(0, "Lose", true);
    }

    setWin(win:number):void {
        this.countUp.visible = true;
        this.countUp.position.set(360, 440);
        this.countUp.text = `${win}x`;
        this.spine.state.setAnimation(0, "Win_Loop", true);
    }

    replay() {
        const option = parseInt(Outsourced.model.data.nextPlayerInteraction.playCrashGame, 10);
        return gsap.timeline()
            .add(() => {
                Outsourced.soundPlayer.playLoopBased("slashGameAnythingElseLoop");
                this.currentMultiplier = 5000;
                this.promptBox.visible = true;
                this.countUp.visible = false;

                if (Outsourced.model.isGodModeDeluxe) {
                    this.godModeDeluxeText.visible = true;
                    this.startButton.enable(false);
                    this.startButton.alpha = 1;
                    this.replayClick.position.x = 360;
                } else {
                    this.text.visible = true;
                    this.godModeDeluxeText.visible = false;
                    this.yesButton.enable(false);
                    this.noButton.enable(false);
                    this.yesButton.alpha = 1;
                    this.noButton.alpha = 1;
                    this.replayClick.position.x = option == 0 ? 510 : 210;
                }
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 1}), '<')
            .add(() => {
                this.replayClick.show();
                this.replayClick.playLoop();
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
            }, '>1')
            .add(() => {
                this.replayClick.hide();
                this.replayClick.stopLoop();
                this.replayClick.setFrame(0);
                Outsourced.apiPlugin.betHandler.zeroBet({playCrashGame:option});
            }, `>${this.replayClick.totalDuration}`)
            .add(() => {

                this.yesButton.alpha = 0;
                this.noButton.alpha = 0;
                this.startButton.alpha = 0;
                this.godModeDeluxeText.visible = false;
                this.crashedInstantly = false;
                this.hasStarted = false;
                this.lostGame = false;
                this.spine.alpha = 1;
                this.promptBox.visible = false;
                this.confirmationText.visible = false;
                this.text.visible = false;
                this.hasPressedButton = false;
                this.logo.visible = true;
                Outsourced.soundPlayer.fadeOutMusic();

                this.alpha = 1;
                this.spine.alpha = 1;
                SpineGSAPWrapper.createTimeline(this.spine, 0, "Gaming_Intro_A").progress(1);
            }, '>1')
    }
}